import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'profile-button-renderer',
    templateUrl: './profile-button-renderer.component.html',
    standalone: false
})
export class ProfileButtonRendererComponent {
  public buttontext: string = '';
  class: string = '';
  //isDependentFunctionName: boolean = false;
  dependentFunctionName:string = '';
  // //Xeroaction: string = "XeroAction";
  // viewdetailaction: string = "ViewDetailAction";
  // //multiformatdownloadaction: string = "MultiFormatDownloadAction";
  // actionButtons: any[] = [];
  // params: ICellRendererParams;
  // data: any = {};

  // constructor() {}

  // onUserAction(action) {
  //   this.params.data.userAction = action;
  //   this.params.node.setData(this.params.data);
  //   this.params.eGridCell.click();
  // }

  // initilize(params: ICellRendererParams) {
  //   if (params && params.data) {
  //     this.params = params;
  //     this.data = params.data;
  //     this.actionButtons = JSON.parse(JSON.stringify(params.colDef?.headerComponentParams));
  //   } else {
  //     this.actionButtons = [];
  //   }
  // }

  // agInit(params: any): void {
  //   this.initilize(params);
  // }

  // refresh(params: any): boolean {
  //   this.initilize(params);
  //   return true;
  // }

  initilize(params: ICellRendererParams) {
    // if (params.getValue()) {
    //   this.buttontext = params.getValue();
    // }
    // else {
    //   this.buttontext = '';
    // }
    this.buttontext = params.getValue();
    if (params.data && params.data.dependentFunctionName) {
      this.class = 'btn eod-btn-outline-primary btn-sm';
      this.dependentFunctionName = params.data.dependentFunctionName;
    } 
    else {
      this.class = 'btn eod-btn-primary btn-sm';
      this.dependentFunctionName = '';
    }
  }


  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}